export default __webpack_public_path__ + "static/media/camping-cta.00d22bce.png";